export default "__VITE_ASSET__DjdEWG39__"